import { useTranslation } from 'react-i18next';
const REPRESENTATION_TRANSFORMATION_LABELS = Object.freeze({
  normalizationTo70dB: 'normalization to 70 dB',
});

export default function RepresentationTransformationsCitation({ transformations = [], labelT = null }) {
  const { t } = useTranslation();
  const citationT = labelT || t;
  if (!transformations.length) return null;

  return (
    <>
      <br />
      <em>
        {citationT('changes_made', 'Changes')}: {' '}
        {transformations.map(({ key, labelKey }, index) => (
          <span key={key}>
            {index > 0 ? ', ' : ''}
            {REPRESENTATION_TRANSFORMATION_LABELS[key] || citationT(labelKey, key)}
          </span>
        ))}
      </em>
    </>
  );
}
